module.exports = __webpack_public_path__ + "img/white.c96bf090.png";